module.exports = __webpack_public_path__ + "static/media/best-express.f0777f7a.svg";